<div class="message"
     [class.message--user]="message().role === 'user'"
     [class.message--assistant]="message().role === 'assistant'">

  @if (message().role === 'assistant') {
    <div class="message__avatar">
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <path d="M12 2a4 4 0 0 1 4 4v2a4 4 0 0 1-8 0V6a4 4 0 0 1 4-4z"/>
        <path d="M16 14H8a4 4 0 0 0-4 4v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2a4 4 0 0 0-4-4z"/>
      </svg>
    </div>
  }

  <div class="message__bubble"
       [class.message__bubble--user]="message().role === 'user'"
       [class.message__bubble--assistant]="message().role === 'assistant'"
       [class.message__bubble--error]="message().status === 'error'">

    <div class="message__content" [innerHTML]="renderedContent"></div>

    @if (message().status === 'streaming' && message().role === 'assistant') {
      @if (message().content) {
        <!-- 流式打字中：闪烁竖线光标 -->
        <span class="message__cursor"></span>
      } @else {
        <!-- 等待响应中：三个点打字动画 -->
        <span class="message__typing">
          <i></i><i></i><i></i>
        </span>
      }
    }

    <div class="message__footer">
      <span class="message__time">{{ messageTime }}</span>
      @if (message().role === 'assistant' && message().status === 'done') {
        <button class="message__copy-btn" (click)="copyContent()" title="{{ 'chatMessage.copy' | translate }}">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <rect x="9" y="9" width="13" height="13" rx="2"/>
            <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/>
          </svg>
        </button>
      }
    </div>
  </div>
</div>
